import React, {useState} from 'react';
import Button from '@mui/material/Button';
import SearchField from './SearchField';

export default props => {
    const [searchValue, setSearchValue] = useState()
    const {searchFields, setList, handleSearch} = props

    const handleRensa = () => {
        setList([])
        setSearchValue()
    }    

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            handleSearch(searchValue)
        }
    }

    const show = (fld, value) => (fld.hiddenIf?value[fld.hiddenIf]?false:true:true) && (fld.notHiddenIf?value[fld.notHiddenIf]?true:false:true)

    return(
        <>
        {searchFields?
            <form>
                    {searchFields.filter(fld=> !fld.hiddenInSearch && show(fld, searchValue)).map(fld => 
                        <SearchField fld={fld} value={searchValue} setValue={setSearchValue} handleKeyPress={handleKeyPress} />
                    )}
                    <p/>
                    <div style={{marginTop:20, marginBotton:20}}>
                    <Button type="button" color="inherit" variant="outlined" onClick={()=>handleSearch(searchValue)} >Sök</Button>
                    &nbsp;&nbsp;
                    <Button type="button" color="inherit" variant="outlined" onClick={handleRensa}>Rensa</Button>
                    </div>
            </form>
        :
            <h3>Sökfält saknas</h3>            
        }
        </>
    )
}

